/**
 * Created by christiancueni on 03/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */

import { RolesActionTypes } from './roles.actions';
import { SchoolRole } from './roles.model';
import { CustomAction } from '../actions/CustomAction';

export interface State {
    roles: SchoolRole[];
    loading: boolean;
    errors: Object[];
}

export const initialRoleState: State = {
    roles: [],
    loading: false,
    errors: []
};

export function reducer(state = initialRoleState, action: CustomAction): State {
    switch (action.type) {
        case RolesActionTypes.LOAD_ROLES:
            return Object.assign({}, state, {
                loading: true,
            });

        case RolesActionTypes.LOAD_ROLES_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                roles: action.payload,
                errors: []
            });

        case RolesActionTypes.LOAD_ROLES_FAIL:
            return Object.assign({}, state, {
                loading: false
            });

        case RolesActionTypes.UPDATE_ROLES:
            return Object.assign({}, state, {
                loading: true
            });

        case RolesActionTypes.UPDATE_ROLES:
            return Object.assign({}, state, {
                loading: false,
                errors: action.payload
            });

        case RolesActionTypes.UPDATE_ROLES_FAIL:
            return Object.assign({}, state, {
                loading: false,
                roles: action.payload['data'],
                errors: action.payload['errors']
            });

        case RolesActionTypes.RESET_ROLES:
            return Object.assign({}, initialRoleState)

        default: {
            return state;
        }
    }
}

export const getRoles = (state: State) => state.roles;
export const getErrors = (state: State) => state.errors;

